export default function Guarantee() {
  return (
    <section id="garantia" className="py-20" style={{ background: 'transparent' }}>
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div
          className="glass home-card flex flex-col md:flex-row items-center gap-10 max-w-4xl mx-auto rounded-3xl p-10 md:p-12"
          style={{
            backdropFilter: 'blur(18px)',
            WebkitBackdropFilter: 'blur(18px)',
            border: '1px solid rgba(200,131,42,0.15)',
            boxShadow: '0 2px 16px rgba(0,0,0,0.04)',
          }}
        >
          {/* Shield icon */}
          <div
            className="w-20 h-20 flex items-center justify-center rounded-2xl flex-shrink-0"
            style={{ background: 'var(--badge-bg)', border: '1.5px solid rgba(200,131,42,0.20)' }}
          >
            <i className="ri-shield-check-line text-3xl" style={{ color: 'var(--gold)' }} />
          </div>

          {/* Content */}
          <div>
            <h2
              className="text-2xl md:text-3xl font-bold mb-3"
              style={{ color: 'var(--heading-ink)', fontFamily: "'DM Sans', sans-serif", fontWeight: 800, letterSpacing: '-0.03em' }}
            >
              Reembolso garantido em 7 dias
            </h2>
            <p
              className="text-base leading-relaxed mb-5"
              style={{ color: 'var(--text-strong)', fontFamily: "'DM Sans', sans-serif", fontWeight: 300 }}
            >
              Se sentir que a música não traduziu sua história ou não chegou perto do que você imaginava, é só falar com a gente.{' '}
              <strong style={{ fontWeight: 600, color: 'var(--heading-ink)' }}>Refazemos do zero ou devolvemos cada centavo</strong> — sem formulários, sem enrolação.
            </p>
            <div className="flex flex-wrap gap-5">
              {[
                { icon: 'ri-refund-2-line', text: 'Reembolso total' },
                { icon: 'ri-time-line', text: '7 dias de garantia' },
                { icon: 'ri-customer-service-2-line', text: 'Suporte humano' },
              ].map((item) => (
                <div key={item.text} className="flex items-center gap-2">
                  <i className={`${item.icon} text-base`} style={{ color: 'var(--gold)' }} />
                  <span
                    className="text-sm font-medium"
                    style={{ color: 'var(--earth-strong)', fontFamily: "'DM Sans', sans-serif" }}
                  >
                    {item.text}
                  </span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
